import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerPwaServiceWorker } from './pwa/serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { recordWebVital } from './utils/instrumentation';
import { initializeProductionTelemetry } from './observability/productionTelemetry';

initializeProductionTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals(recordWebVital);
registerPwaServiceWorker();
